var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.806 12.953 8.556-8.556c1.834-1.834-1.018-4.686-2.852-2.853l-8.557 8.557-8.556-8.557C2.563-.289-.29 2.564 1.544 4.397l8.557 8.556-8.557 8.557c-1.833 1.834 1.019 4.686 2.853 2.852l8.556-8.556 8.557 8.556c1.834 1.834 4.686-1.018 2.852-2.852l-8.556-8.557Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.25006b06cd14e9c0a9f68cd794c81f0f.svg";
export { ForwardRef as ReactComponent };